import { Component, NgZone, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppDetailLayout2Data } from './app-detal-layout-2.model';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifc-app-detail-layout-2',
    templateUrl: './app-detail-layout-2.component.html',
    styleUrls: ['./app-detail-layout-2.component.scss'],
    standalone: false
})
export class AppDetailLayout2Component implements OnInit {

    contentScrolled = false;
    sidenavOpened = true;
    data: AppDetailLayout2Data = new AppDetailLayout2Data();

    constructor(
        private ngZone: NgZone,
        private route: ActivatedRoute,
        breakpointObserver: BreakpointObserver
    ) {
        breakpointObserver.observe([
            Breakpoints.XSmall,
            Breakpoints.Small,
        ]).subscribe(result => {
            if (result.matches)
                this.sidenavOpened = false;
            else
                this.sidenavOpened = true;
        });
    }

    ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this))
        .subscribe(this.dataSet.bind(this));
    }

    dataSet(data: AppDetailLayout2Data) {
        this.data = new AppDetailLayout2Data(data);
    }

    @HostListener('window:scroll', ['$event'])
    onContentScrolled(event?) {
      this.ngZone.run(() => {
        this.contentScrolled = event?.currentTarget.scrollY > 0;
      });
    }
}
